import { BackArrow } from "themes/Icon";
import style from "../ward_details.module.scss";

function Header({ handleClose }) {
  return (
    <div
      className={`flex align-center w-full gap-2 ${style["header-container"]}`}
    >
      <span onClick={handleClose} className="pointer">
        <BackArrow />
      </span>
      <h2 className="page-title">Ward details</h2>
    </div>
  );
}

export default Header;
